/**
 * Created by comoon on 3/1/16.
 */

var $ = require("jquery");

var moment = require("moment");

moment.locale("zh-cn");

var ReactDOM = require("react-dom");

var ALikeStore = require("../store/ALikeStore");

var QuoteApplyFormWrapper = require("../detail-m/QuoteApplyFormWrapper");

var QuoteRecordList = require("../detail-m/QuoteRecordList");

var QuoteRecordListB = require("../detail-m-b/QuoteRecordList");

var ExtraProductTips = require("../detail-m/ExtraProductTips");

var ProductList = require("../detail-m/ProductList");

var Dispatcher = require("../Dispatcher");

var {ActionConstants, ElementConstants, EventConstants} = require("../Constants");

var ALikeStore = require("../store/ALikeStore");

var TripType = require("../conf/trip-type");

$(function () {

    var tripContainer = $(".alike-container");

    var daysNav = $(".days-nav");

    var tripDays = $(".trip-days");

    var navTrigger = tripDays.find(".nav-trigger");

    var footer = $(".js-footer");

    var bookingManual = $(".js-booking-manual");

    var tripInfo = tripContainer.data();

    var win = $(window);

    var body = $("body");

    Dispatcher.dispatch({type: ActionConstants.INIT_TRIP_INFO, data: tripInfo});

    tripDays.on("click", ".trip-day", function(){
        var item = $(this);

        var tripDay = tripDays.find(".trip-day.day-" + item.data("day")).addClass("selected");

        tripDay.siblings(".selected").removeClass("selected");
    });

    daysNav.on("click", ".day-city.switcher", function () {

        var item = $(this);

        var tripDay = tripDays.find(".trip-day.day-" + item.data("day")).addClass("selected");

        tripDay.siblings(".selected").removeClass("selected");

        daysNav.addClass("collapsed");

        navTrigger.removeClass("collapsed");

        var top = tripDay.offset().top - $(ElementConstants.TOP_NAV_CLASS).height();

        body.removeClass("pop-lock");

        tripDays.__top = null;

        delete tripDays.__top;

        win.scrollTop(top);
    });

    daysNav.on("click", ".closer", function () {

        daysNav.addClass("collapsed");

        navTrigger.removeClass("collapsed");

        body.removeClass("pop-lock");

        win.scrollTop(tripDays.__top);

        tripDays.__top = null;

        delete tripDays.__top;
    });

    tripDays.on("click", ".nav-trigger", function () {

        navTrigger.addClass("collapsed");

        daysNav.removeClass("collapsed");

        tripDays.__top = win.scrollTop();

        body.addClass("pop-lock");
    });
    var trip = ALikeStore.get_tripBasicInfo();
    //准AA or 准AB
    var isTripA = (trip.tripType === TripType.WalleA.code) ? true: false;
    var isTripB = (trip.tripType === TripType.WalleB.code) ? true: false;

    if(isTripA){
        ReactDOM.render(<QuoteApplyFormWrapper />, $(".quote-container")[0]);
        ReactDOM.render(<QuoteRecordList />, $("#quoteRecordList")[0]);
    }else{
        ReactDOM.render(<QuoteRecordListB />, $("#quoteRecordList")[0]);
        $("#quoteApply").remove();
    }


    ReactDOM.render(<ProductList />, $("#inProductList")[0]);

    ReactDOM.render(<ProductList absent/>, $("#absentProductList")[0]);

    ReactDOM.render(<ExtraProductTips/>, $('.extra-tips-price-profile')[0]);

    footer.on("click", ".book", function () {

        var btn = $(this);

        var top = 0;

        if (btn.hasClass('to-form')) {

            top = $(".quote-apply-profile").offset().top - $(ElementConstants.TOP_NAV_CLASS).height();

        } else if (btn.hasClass('to-ql')) {

            top = $(".quote-record-container").offset().top - $(ElementConstants.TOP_NAV_CLASS).height();
        }

        win.scrollTop(top);
    });

    bookingManual.on("click", ".block-text", function () {

        var block = $(this);

        block.toggleClass('is-current');

        if (block.hasClass('is-current')) {

            block.find(".txt").show();

        } else {

            block.find(".txt").hide();
        }
    });

    ALikeStore.on(EventConstants.AJAX_RETRIEVE_RECORD_LIST_COMPLETE, function () {
        var bookEl = footer.find(".book");

        if (ALikeStore.is_tripHasBeenBought()){
            bookEl.text("已预定");

        }else{

            if (ALikeStore.has_quoteValid()) {

                bookEl.text("选择日期预定").removeClass("to-form").addClass("to-ql");
            } else {

                if( isTripA ){
                    bookEl.text("获取实时价格").removeClass("to-ql").addClass("to-form");
                }else if( isTripB ){
                    bookEl.remove();
                }

            }

        }
    });

    var quteContainer = $("#quoteRecordList");
    var dayItems = $(".trip-day.switcher div.main");
    var startItem = $(".trip-day.start div.main");
    var endItem = $(".trip-day.end div.main");
    var weekdays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];

    quteContainer.on("click", ".quote-record", function(){
        if($(this).hasClass("expanded")){
            return;
        }
        $(".trip-day.switcher div.d").remove();
        $(".trip-day.start div.d").remove();
        $(".trip-day.end div.d").remove();
        setWeekDay(this);
    });

    quteContainer.on("click", ".version", function(){
        $(".trip-day.switcher div.d").remove();
        $(".trip-day.start div.d").remove();
        $(".trip-day.end div.d").remove();
        setWeekDay(this);

    });
    /**
     * 启程: startDay
     * DAY-1 +startOffset
     * DAY-2 DAY-1+1
     * 返程: startDay + 天数+ endOffset
     * @param e
     */
    function setWeekDay(e){
        var startOffset = window.startOffset || 0;
        var endOffset = window.endOffset || 0;
        var startDate = $(e).data().startdate;
        var dayLength = dayItems.length;
        var endDate = null;
        var setp = 0;
        //启程
        $(startItem).append("<div class='d'>"+  moment(startDate).format("YYYY-M-DD") +" "+ weekdays[moment(startDate).day()] +"</div>");
        _.each(dayItems, function(i,j){
            setp = j===0 ? startOffset+j : setp+1;
            var date = moment(startDate).add("day", setp);
            var d = date.day();
            var day = date.format("YYYY-MM-DD");
            var week = weekdays[d];
            endDate = j===dayLength-1 ? date : endDate;
            $(i).append("<div class='d'>"+ day +" "+ week +"</div>")
        })
        //返程
        $(endItem).append("<div class='d'>"+  moment(endDate).format("YYYY-M-DD") +" "+ weekdays[moment(endDate).day()] +"</div>");
    }
});

require("../detail-m/nav-follow");



/** WEBPACK FOOTER **
 ** ./script/entry/detail-m.js
 **/